import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import FAQ from './pages/FAQ';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import WorkWithUs from './pages/WorkWithUs';
import ScanSmile from  './pages/ScanSmile';
import ScanSmile2 from  './pages/ScanSmile2';
import Ortho from  './pages/Ortho';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/scan" || location.pathname === "/scan2"|| location.pathname === "/ortho";
  return (
    <div className="min-h-screen bg-gray-50">
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/scan" element={<ScanSmile />} />
        <Route path="/scan2" element={<ScanSmile2 />} />
        <Route path="/ortho" element={<Ortho />} />
      </Routes>
    </div>
  );
}

export default App;
